
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {Router} from "@angular/router";
import { FormsModule, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {HttpModule, Http, XHRBackend, RequestOptions} from '@angular/http';
import {MenubarModule} from 'primeng/primeng';


import { MamRoutingModule, MamMenuVerticalComponent} from './mam_app_vertical.menu';
import {MamLoginComponent,MamLoginModule} from './mam_login.component';
import {MamContentsComponent,MamContentsModule} from './mam_contents.component';


import {CompanyManagerPageModule} from './page/system/company_mgr.page';
import {FrontMainModule} from "./page/main/front_main";
import {DeviceConditionModule} from "./page/device/device_condition";
import {AppManagementModule} from "./page/device/app_management";
import {DeviceStatisticsModule} from "./page/device/device_statistics";
import {CertManagementModule} from "./page/device/cert_management";
import {RemoteManagementModule} from "./page/device/remote_management";
import {DeviceLocationInfoModule} from "./page/device/device_location_info";
import {PolicyConfigNewModule} from "./page/policy/policy_config_new";
import {PolicyConfigLocationModule} from "./page/policy/policy_config_location";
import {PolicyApplyConditionNewModule} from "./page/policy/policy_apply_condition_new";
import {PolicyResourceModule} from "./page/policy/policy_resource";
import {PolicyScheduleModule} from "./page/policy/policy_schedule";
import {HolidayManagementModule} from "./page/policy/holiday_management";
import {InstallationLogModule} from "./page/log/installation_log";
import {LostManagementModule} from "./page/log/lost_management";
import {IssueLogModule} from "./page/log/issue_log";
import {AuditLogModule} from "./page/log/audit_log";
import {AdminManagementModule} from "./page/system/admin_management";
import {DeptManagementModule} from "./page/system/dept_management";
import {DeviceTypeManagementModule} from "./page/system/device_type_management";
import {DeviceUserManagementModule} from "./page/system/device_user_management";
import {NoticeManagementModule} from "./page/system/notice_management";
import {SystemSettingModule} from "./page/system/system_setting";
import {UserAgreementManagementModule} from "./page/system/user_agreement_management";
import {CompanyTreeModule} from "./page/device/company_tree";
import {LogModule} from "./page/log/log";
import {SetupStateLogModule} from "./page/log/setup_state_log";
import {UsbStorageLogModule} from "./page/log/usb_storage_log";
import {OfficeAppLogModule} from "./page/log/office_app_log";
import {LogCommonTableModule} from "./page/log/log_common_table";
import {CommonModule, LocationStrategy, HashLocationStrategy, APP_BASE_HREF} from "@angular/common";
import {MamAppComponent} from "./mam_app.component";
import {RadioButtonModule,InputTextModule,ButtonModule,PasswordModule, PanelModule} from "primeng/primeng";
import {ExUserDialogModule} from "./component/user_dlg.component";
import {UserGroupCheckTreeModule} from "./component/user_checktree.component";
import {VisitorLogStatisticsModule} from "./page/visitor/visitor_log_statistics";
import {VisitorManagementModule} from "./page/visitor/visitor_management";
import {VisitorLocationModule} from "./page/visitor/location_verification";
import {VisitorLocationLogModule} from "./page/visitor/location_verification_log";
import {HeartBeatLogModule} from "./page/log/heartbeat_log";
import {CookieService} from "angular2-cookie/services/cookies.service";
import {PanelMenuModule} from "primeng/components/panelmenu/panelmenu";
import {OTPHistoryModule} from "./page/log/otp_history";
import {DBSyncLogModule} from "./page/log/dbSync_log";


import {TranslatePipe}   from "./translate/translate.pipe";
import {TRANSLATION_PROVIDERS}   from "./translate/translations";
import {TranslateServiceForm }   from "./translate/translate.service";
import {TranslatePipeMoudle}   from "./translate/translate.module.pipe";

import {httpFactory} from "./factory/http.factory";
import {Logger, Options, Level } from "angular2-logger/core";
import {MainPipeMoudle} from "./pipe/main.pipe"
import { environment }    from '../environments/environment';

import {BrowserDomAdapter} from '@angular/platform-browser/src/browser/browser_adapter';
import {EmergencyLogModule} from "./page/log/emergency_log";
import {OfficeAppVersionShowModule} from "./page/device/officeapp_version_show";
import {InOutShowModule} from "./page/log/inOutShow";

@NgModule({
  declarations: [
    MamAppComponent,MamMenuVerticalComponent,MamLoginComponent,MamContentsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    MamRoutingModule,
    MenubarModule,
    PanelMenuModule,
    CommonModule,
    CompanyManagerPageModule,
    FrontMainModule,
    DeviceConditionModule,
    AppManagementModule,
    DeviceStatisticsModule,
    CertManagementModule,
    RemoteManagementModule,
    DeviceLocationInfoModule,
    PolicyConfigNewModule,
    PolicyConfigLocationModule,
    PolicyApplyConditionNewModule,
    PolicyResourceModule,
    PolicyScheduleModule,
    HolidayManagementModule,
    InstallationLogModule,
    LostManagementModule,
    IssueLogModule,
    AuditLogModule,
    AdminManagementModule,
    DeptManagementModule,
    DeviceTypeManagementModule,
    DeviceUserManagementModule,
    NoticeManagementModule,
    SystemSettingModule,
    UserAgreementManagementModule,
    LogModule,
    CompanyTreeModule,
    SetupStateLogModule,
    UsbStorageLogModule,
    OfficeAppLogModule,
    LogCommonTableModule,
    RadioButtonModule,InputTextModule,ButtonModule,PasswordModule, PanelModule, ReactiveFormsModule,
    ExUserDialogModule,
    UserGroupCheckTreeModule,
    VisitorLogStatisticsModule,
    VisitorManagementModule,
    MainPipeMoudle,
    TranslatePipeMoudle,
    HeartBeatLogModule,
    OTPHistoryModule,
    DBSyncLogModule,
    EmergencyLogModule,
    VisitorLocationModule,
    VisitorLocationLogModule,
    OfficeAppVersionShowModule,
    InOutShowModule
  ],
  providers: [Logger, CookieService, TRANSLATION_PROVIDERS, TranslateServiceForm,{provide: LocationStrategy, useClass: HashLocationStrategy},
                                                                                                     {provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions, TranslateServiceForm, Router]
        }],
  bootstrap: [MamAppComponent]
})
export class AppModule {
  constructor(private logger : Logger, private _translate : TranslateServiceForm) {
      this.logger.level= environment.logger.level;

  }

}



// WEBPACK FOOTER //
// ./src/app/mam_app.module.ts